module.exports = "vec2 getTextureUv(vec2 pos, float maxWidth, float maxHeight){\r\n    float step = 1.0 / min(maxWidth, maxHeight);\r\n    float u = pos.x * step + 0.5;\r\n    float v = pos.y * step + 0.5;\r\n\treturn vec2(fract(u), fract(v));\r\n}\r\n\r\nvec2 getUv(vec2 pos, float maxWidth, float maxHeight){\r\n    vec2 newPos;\r\n    newPos.x = (pos.x + maxWidth / 2.0) / maxWidth;\r\n    newPos.y = (pos.y + maxHeight / 2.0) / maxHeight;\r\n    return newPos;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/js/shader/function/getUV.glsl
// module id = 4
// module chunks = 0